import { useEffect, useState } from 'react';
import Lang from '../../language/services/Lang'
import { Language } from '../../../components/language/services/constants';

export const useReturnInfoDisplayData = (r, clientId, lang) => {
    const [nameDisplayString, setNameDisplayString] = useState('—');
    const [productDisplayString, setProductDisplayString] = useState('—');
    const [linkLocation, setLinkLocation] = useState(null);

    const toTitleCase = (str) => {
        // handle casing (this is ugly, I know but if I use css to handle casing, the 'et' 
        // in the french format becomes capilalized, which I don't want)
        return str.replace(/(^|[\s-])\S/g, function (t) { return t.toUpperCase() });
    }

    const getClientFullNames = (r) => {
        var retval;
        var isCoupled = r.type.toLowerCase().startsWith("couple");

        // get the primary name
        var primary = r.primaryFirstName ? r.primaryFirstName + (r.primaryLastName && (' ' + r.primaryLastName)) : null;

        if (!primary) {
            // return just the dash if there is no name given.
            return '—';
        } else {
            // capitalize primary name
            primary = toTitleCase(primary.toLowerCase());

            if (isCoupled) {
                // get the spouse's name
                var spouse = r.spouseFirstName ? r.spouseFirstName + (r.spouseLastName && (' ' + r.spouseLastName)) : null;
                // capitalize spouse name, or replace with 'spouse' if null
                spouse = spouse ? toTitleCase(spouse.toLowerCase()) : Lang.getCurrentValue('ReturnInfo.Placeholders.Spouse');
                // put it in the template.
                retval = Lang.getCurrentValue('ReturnInfo.NameFormatter.' + r.type, { primary, spouse });
            } else {
                retval = Lang.getCurrentValue('ReturnInfo.NameFormatter.' + r.type, { primary });
            }
        }

        return retval;
    }

    const makeHref = (r, clientId) => {
        var route = '#';

        // Deleted returns are not clickable
        if (!r.isDeleted) {
            switch (r.product) {
                case 'DIY':
                    route = `/returns/${r.id}/clients/${clientId}/year/${r.taxYear}`
                    break;
                case 'PRESALE':
                    route = `/presales/${r.id}/year/${r.taxYear}?accountId=${clientId}`
                    break;
                case 'OTE':
                    route = `/otes/${r.id}/year/${r.taxYear}`
                    break;
                case 'VDO':
                    route = `/tickets/${r.id}`
                    break;
                case 'VIR':
                    route = `/tickets/${r.id}`
                    break;
                case 'RTE':
                    route = `/tickets/${r.id}`
                    break;
                default: break;
            }
        }

        return route;
    }

    useEffect(() => {
        let prodDisplayStr = ''
        const title = lang.toUpperCase() === Language.FRENCH ? r.titleFr : r.titleEn;
        if (r.product === 'PRESALE') {
            setNameDisplayString(Lang.getCurrentValue('ReturnInfo.Product.' + r.product))
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.DIY')
        } else if (r.product === 'OTE') {
            setNameDisplayString(title)
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.OTE')
        } else if (r.product === 'VDO') {
            setNameDisplayString(title)
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.VDO')
        }
        else if (r.product === 'VIR') {
            setNameDisplayString(title)
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.VIR')
        }
        else if (r.product === 'RTE') {
            setNameDisplayString(title)
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.RTE')
        }
        else {
            setNameDisplayString(getClientFullNames(r))
            prodDisplayStr = Lang.getCurrentValue('ReturnInfo.Product.' + r.product)
        }

        prodDisplayStr += " | "
        prodDisplayStr += Lang.getCurrentValue("ReturnInfo.Type." + r.type)
        if (r.product !== 'OTE' && r.product !== 'VDO' && r.product !== 'VIR' && r.product !== 'RTE') {
            prodDisplayStr += " | " + Lang.getCurrentValue("ReturnInfo.Package." + (r.platforms && r.platforms.length ? r.platforms[0] : "ONLINE") + "." + r.package)
        }
        if (r.upgrades) {
            for (var u of r.upgrades) {
                prodDisplayStr += " | " + Lang.getCurrentValue("ReturnInfo.Upgrade." + u)
            }
        }
        setProductDisplayString(prodDisplayStr);
    }, [r, lang]);

    useEffect(() => {
        setLinkLocation(makeHref(r, clientId));
    }, [r, clientId])

    return [productDisplayString, nameDisplayString, linkLocation];
}